import React, { useEffect, useState } from 'react';
import CardContainer from 'components/Tvendo/Common/CardContainer';
import RegularButton from 'components/CustomButtons/Button';
import GridContainer from 'components/Grid/GridContainer';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { wsGetAll, wsGet } from 'services/WService';
import GridItem from 'components/Grid/GridItem';
import { TextField } from '@material-ui/core';
// Iconos
import { useParams } from 'react-router-dom';
import { wsUpdate } from 'services/WService';
// Permisos
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';

function ShowConvertion() {
  const { id } = useParams();

  const [zones, setZones] = useState([]);
  const [warehouses, setWarehouses] = useState([]);
  const [convertion, setConvertion] = useState({ Quantity: 1 });
  const [processing, setProsessing] = useState(false);

  async function changeState(stateMigrate) {
    setProsessing(true);
    let res = await wsUpdate(`logi/convertion/${id}/change-state`, {
      state_migrate: stateMigrate,
    });
    setProsessing(false);
    if (res.success) {
      window.alert(res.message);
      setConvertion((convertion) => ({ ...convertion, state_migrate: stateMigrate }));
    } else {
      window.alert(res.message);
    }
  }

  async function getConvertion() {
    let res = await wsGet('logi/convertion', id);
    if (res.success) {
      setConvertion(res.data);
    } else {
      window.alert(res.message);
    }
  }

  async function listWarehouses() {
    let res = await wsGetAll('logi/warehouse?warehouse_type=N');
    if (res.success) {
      setWarehouses(res.data);
    }
  }

  async function listZones() {
    let res = await wsGetAll('base/zone');
    if (res.success) {
      setZones(res.data);
    }
  }

  useEffect(() => {
    listZones();
    listWarehouses();
    getConvertion();
  }, []);

  return (
    <GridContainer>
      <GridItem xs={12}>
        <CardContainer title="Nueva orden de conversión">
          <GridContainer>
            {/* Zonal */}
            <GridItem xs={12} sm={6} md={4} lg={3} xl={2}>
              <Autocomplete
                options={zones}
                getOptionLabel={(zone) => zone.description}
                renderInput={(params) => (
                  <TextField {...params} label="Zonal" margin="normal" required />
                )}
                value={zones.find((zone) => zone.id === parseInt(convertion.base_zone_id)) || null}
                disabled
                onChange={(_, zone) => {
                  if (zone === null)
                    return setConvertion((convertion) => ({
                      ...convertion,
                      base_zone_id: undefined,
                    }));
                  setConvertion((convertion) => ({ ...convertion, base_zone_id: zone.id }));
                }}
              />
            </GridItem>
            {/* Almacén */}
            <GridItem xs={12} sm={6} md={4} lg={3} xl={2}>
              <Autocomplete
                options={warehouses}
                getOptionLabel={(warehouse) => warehouse.WhsName}
                renderInput={(params) => (
                  <TextField {...params} label="Almacén" margin="normal" required />
                )}
                value={
                  warehouses.find(
                    (warehouse) => warehouse.id === parseInt(convertion.logi_warehouse_id),
                  ) || null
                }
                disabled
                onChange={(_, warehouse) => {
                  if (warehouse === null)
                    return setConvertion((convertion) => ({
                      ...convertion,
                      logi_warehouse_id: undefined,
                    }));
                  return setConvertion((convertion) => ({
                    ...convertion,
                    logi_warehouse_id: warehouse.id,
                  }));
                }}
              />
            </GridItem>
            {/* Valorizado */}
            <GridItem xs={12} sm={6} md={4} lg={3} xl={2}>
              <TextField
                label="Valorizado"
                type="number"
                margin="normal"
                fullWidth
                value={0}
                InputProps={{ readOnly: true }}
              />
            </GridItem>
          </GridContainer>
        </CardContainer>
      </GridItem>

      {/* Producto padre */}
      <GridItem xs={5}>
        <CardContainer icon={null} title="Lista de materiales">
          <GridContainer>
            <GridItem xs={12}>
              ({convertion?.from_product?.ItemCode}) {convertion?.from_product?.ItemName}
            </GridItem>
            <GridItem xs={12}>
              <TextField
                label="Factor"
                type="number"
                value={parseInt(
                  !!convertion.father_quantity
                    ? convertion?.PlannedQty / convertion?.father_quantity
                    : 0,
                )}
                disabled
              />
            </GridItem>
          </GridContainer>
        </CardContainer>
      </GridItem>

      {/* Cantidad / Procesar */}
      <GridItem xs={2}>
        <TextField
          label="Cantidad"
          type="number"
          disabled
          value={convertion.father_quantity || 0}
          inputProps={{ min: 1 }}
        />
        {convertion.state_migrate === 'D' ? (
          <RegularButton color="warning" onClick={() => changeState('V')} disabled={processing}>
            Validar
          </RegularButton>
        ) : convertion.state_migrate === 'V' ? (
          <>
            <AllowedGuard
              permission={ConstantPermissions.LOGI_CONVERTIONS_CONFIRM}
              component={
                <RegularButton
                  color="primary"
                  onClick={() => window.alert('No tiene permisos para realizar esta acción')}
                  disabled={processing}
                >
                  Aprobar
                </RegularButton>
              }
            >
              <RegularButton color="primary" onClick={() => changeState('X')} disabled={processing}>
                Aprobar
              </RegularButton>
            </AllowedGuard>
            <RegularButton color="primary" onClick={() => changeState('D')} disabled={processing}>
              Borrador
            </RegularButton>
          </>
        ) : convertion.state_migrate === 'X' ? (
          <RegularButton color="warning" disabled>
            Procesando...
          </RegularButton>
        ) : (
          <RegularButton color="success" disabled>
            Procesado
          </RegularButton>
        )}
      </GridItem>

      {/* Producto Destino */}
      <GridItem xs={5}>
        <CardContainer icon={null} title="Producto destino">
          <GridContainer>
            <GridItem xs={12}>
              ({convertion?.to_product?.ItemCode}) {convertion?.to_product?.ItemName}
            </GridItem>
            <GridItem xs={12}>
              <TextField
                label="Cantidad Resultado"
                type="number"
                value={parseInt(!!convertion.PlannedQty ? convertion?.PlannedQty : 0)}
                disabled
              />
            </GridItem>
          </GridContainer>
        </CardContainer>
      </GridItem>
    </GridContainer>
  );
}

export default ShowConvertion;
